import React from 'react';
import { MessageCircle } from 'lucide-react';
import { siteConfig } from '../data/mock';

// Pre-filled WhatsApp messages for different CTAs
const whatsappMessages = {
  quote: 'Olá! Gostaria de solicitar um orçamento para serviços da Box7go. Poderia me passar mais informações?',
  booking: 'Olá! Gostaria de agendar um serviço na Box7go. Quando vocês têm disponibilidade?',
  catalog: 'Olá! Gostaria de ver o catálogo completo de serviços da Box7go.',
  service: (serviceName) => `Olá! Tenho interesse no serviço de ${serviceName}. Poderia me dar mais detalhes e valores?`,
  neighborhood: (neighborhood) => `Olá! Sou de ${neighborhood} e gostaria de saber mais sobre os serviços da Box7go na minha região.`
};

export const WhatsAppButton = ({ 
  className = "", 
  text = "Fale no WhatsApp",
  message = "",
  messageType = "quote", // quote, booking, catalog, service, neighborhood
  serviceName = "",
  neighborhood = "",
  variant = "default" // default, outline, large
}) => {
  const handleClick = () => {
    let finalMessage = message;
    
    if (!finalMessage) {
      if (messageType === 'service' && serviceName) {
        finalMessage = whatsappMessages.service(serviceName);
      } else if (messageType === 'neighborhood' && neighborhood) {
        finalMessage = whatsappMessages.neighborhood(neighborhood);
      } else {
        finalMessage = whatsappMessages[messageType] || whatsappMessages.quote;
      }
    }
    
    const encodedMessage = encodeURIComponent(finalMessage);
    window.open(`${siteConfig.whatsappLink}?text=${encodedMessage}`, '_blank');
  };

  // Variant styles
  const variantStyles = {
    default: 'bg-[#25D366] hover:bg-[#20BA5A] text-white',
    outline: 'bg-white border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white',
    large: 'bg-[#25D366] hover:bg-[#20BA5A] text-white text-lg px-10 py-4'
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center gap-2 ${variantStyles[variant]} font-semibold px-6 py-3 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl ${className}`}
      aria-label={text}
    >
      <MessageCircle className="w-5 h-5" />
      {text}
    </button>
  );
};

export const WhatsAppFloating = () => {
  const handleClick = () => {
    const message = encodeURIComponent('Olá! Vim pelo site da Box7go e gostaria de mais informações sobre os serviços.');
    window.open(`${siteConfig.whatsappLink}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 animate-pulse"
      aria-label="Contato WhatsApp"
      title="Fale conosco no WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </button>
  );
};

// Quick CTA variations for conversion
export const QuickCTA = ({ type = 'quote', serviceName = '', neighborhood = '' }) => {
  const ctas = {
    quote: {
      text: 'Solicitar Orçamento',
      messageType: 'quote'
    },
    booking: {
      text: 'Agendar Agora no WhatsApp',
      messageType: 'booking'
    },
    catalog: {
      text: 'Ver Catálogo no WhatsApp',
      messageType: 'catalog'
    }
  };

  const cta = ctas[type] || ctas.quote;

  return (
    <WhatsAppButton
      text={cta.text}
      messageType={cta.messageType}
      serviceName={serviceName}
      neighborhood={neighborhood}
      variant="large"
    />
  );
};
